// extracted by mini-css-extract-plugin
export default {"products":"yx-z","card":"zx-z","oosMessaging":"Ax-z"};